// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBookResponse

export type WidgetBookApiResponse = {
	bookingId: string;
};

export type WidgetBook = {
	bookingId: string;
};

export function hydrateWidgetBook(data: WidgetBookApiResponse): WidgetBook {
	return { ...data };
}